import { render, staticRenderFns } from "./DownloadWishlistModalV2.vue?vue&type=template&id=2922567f&scoped=true&"
import script from "./DownloadWishlistModalV2.vue?vue&type=script&lang=js&"
export * from "./DownloadWishlistModalV2.vue?vue&type=script&lang=js&"
import style0 from "./DownloadWishlistModalV2.vue?vue&type=style&index=0&id=2922567f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922567f",
  null
  
)

export default component.exports